module.exports = __webpack_public_path__ + "img/icon.299b94a1.png";